import { colors, Container, Divider, Tab, Tabs } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import Page from 'src/components/Page';
import Connections from './Connections';
import Digiport from './Digiport';
import Header from './Header';
import Lokasyon from './Lacation';
import Plaka from './Plate';
import Kayit from './Record';
import Timeline from './Timeline';
import { getUser } from 'src/utils/Common';

const useStyles = makeStyles(theme => ({
  root: {},
  container: {
    marginTop: theme.spacing(3)
  },
  divider: {
    backgroundColor: colors.grey[300]
  },
  content: {
    marginTop: theme.spacing(3)
  }
}));

function Profile({ match, history }) {
  const classes = useStyles();
  const { t } = useTranslation([
    'profile',
    'bulletin',
    'common',
    'file',
    'help',
    'login',
    'material_requirement',
    'navigation',
    'overview',
    'product_detail_control',
    'service_contact',
    'today_summary',
    'warning_center',
    'work_order'
  ]);
  const SessionUser = getUser();
  var TitleApp = "Sirius CRM";
  if (SessionUser.Role === 2) {
    TitleApp = "Sirius Partner"
  }
  const { id, tab: currentTab } = match.params;
  const tabs = [
    { value: 'timeline', label: t('Mesajlar') },
    // { value: 'Plaka', label: t('Plaka') },
    { value: 'connections', label: t('Cihaz') },
    // { value: 'Lokasyon', label: t('Lokasyon') },
    { value: 'Digiport', label: t('Digiport') },
    { value: 'Kayit', label: 'Link' }
  ];

  const handleTabsChange = (event, value) => {
    history.push(value);
  };

  if (!currentTab) {
    return <Redirect to={`/profile/${id}/timeline`} />;
  }

  if (!tabs.find(tab => tab.value === currentTab)) {
    return <Redirect to="/errors/error-404" />;
  }

  return (
    <Page className={classes.root} title={TitleApp}>
      <Header />
      <Container maxWidth="lg">
        <Tabs
          onChange={handleTabsChange}
          scrollButtons="auto"
          value={currentTab}
          variant="scrollable"
          textColor="secondary"
          indicatorColor="primary"
        >
          {tabs.map(tab => (
            <Tab key={tab.value} label={tab.label} value={tab.value} />
          ))}
        </Tabs>
        <Divider className={classes.divider} />
        <div className={classes.content}>
          {currentTab === 'timeline' && <Timeline />}
          {currentTab === 'Plaka' && <Plaka />}
          {currentTab === 'Kayit' && <Kayit />}
          {currentTab === 'connections' && <Connections />}
          {currentTab === 'Lokasyon' && <Lokasyon />}
          {currentTab === 'Digiport' && <Digiport />}
        </div>
      </Container>
    </Page>
  );
}

Profile.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};

export default Profile;
